<template>
  <div class="container">
    <!-- 서브상단영역 -->
    <Banner
      title="mypage"
      subtitle="mypage"
      description="학생들과 함께 그들의 미래를 찾는 일을 하고자 합니다. <br>
        자신의 미래에 관심이 있는 학생 누구에게나 도움을 주고자 합니다."
    />

    <!-- //메뉴 -->
    <div class="width_wrap">
      <Loading v-show="loading" />
      <div class="body_content">
        <!-- 서브 타이틀영역 -->
        <h1 class="sub_subject">mypage<span></span></h1>
        <!-- //서브 타이틀영역 -->
        <!-- 로그인 상태에 따른 분기 처리 -->
        <div v-if="!isLoggedIn">
          <form @submit.prevent="handleSubmit">
            <input type="hidden" name="re_url" value="" />
            <input type="hidden" name="this_domain" />
            <input type="hidden" name="post_action" />
            <input type="hidden" name="mode" />
            <input type="hidden" name="popup" value="" />
            <input
              type="hidden"
              name="form_sess_id"
              value="716vsn2hkvktapfcokmmb69lg7"
            />
            <input type="hidden" name="form_id_name" value="" />
            <div class="glores-B-login">
              <h3 class="glores-B-login-title"><span>회원 로그인</span></h3>

              <!-- 로그인 타입 선택 라디오 버튼 -->
              <div
                class="login-type-selector"
                style="margin-bottom: 15px; text-align: center"
              >
                <label style="margin-right: 20px">
                  <input
                    type="radio"
                    name="login_type_radio"
                    value="user"
                    v-model="loginType"
                  />
                  일반 회원
                </label>
                <label>
                  <input
                    type="radio"
                    name="login_type_radio"
                    value="organization"
                    v-model="loginType"
                  />
                  기관 회원
                </label>
              </div>

              <div class="glores-B-login-form">
                <div class="login-input-box">
                  <ul>
                    <!-- 기관 로그인 시 -->
                    <li v-if="loginType === 'organization'">
                      <label for="input_org_id">기관 아이디</label>
                      <input
                        type="text"
                        name="org_id"
                        id="input_org_id"
                        placeholder="기관 아이디"
                        v-model="form.orgId"
                      />
                    </li>
                    <li>
                      <label for="input_id">{{
                        loginType === "organization"
                          ? "사용자 아이디"
                          : "아이디"
                      }}</label>
                      <input
                        type="text"
                        name="id"
                        id="input_id"
                        :placeholder="
                          loginType === 'organization'
                            ? '사용자 아이디'
                            : '아이디'
                        "
                        required
                        v-model="form.uid"
                      />
                    </li>
                    <li>
                      <label for="input_pw">비밀번호</label>
                      <!-- <input
                                                type="password"
                                                name="pwd"
                                                id="input_pw"
                                                maxlength="16"
                                                placeholder="비밀번호"
                                                required
                                                v-model="form[apiKeys.USER_LOGIN_PWD]"
                                            /> -->
                      <input
                        type="password"
                        name="pwd"
                        id="input_pw"
                        maxlength="16"
                        placeholder="비밀번호"
                        :required
                        v-model="form.password"
                      />
                    </li>
                  </ul>
                </div>

                <div class="login-check-box">
                  <span>
                    <input
                      type="checkbox"
                      name="id_save"
                      id="id_save"
                      value="1"
                      v-model="form.idSave"
                    />
                    <label for="id_save">아이디 저장</label>
                  </span>
                </div>
                <div class="login-btn-submit">
                  <button
                    type="submit"
                    class="btn-login"
                    style="background: #c0c0c0"
                  >
                    로그인
                  </button>
                </div>
                <!-- 소셜 로그인 버튼 영역 (일반 회원 로그인 시에만 표시) -->
                <template v-if="loginType === 'user'">
                  <div
                    class="social-login-buttons"
                    style="
                      margin-top: 20px;
                      text-align: center;
                      padding-top: 20px;
                      border-top: 1px solid #eee;
                    "
                  >
                    <p
                      style="margin-bottom: 15px; font-size: 0.9em; color: #666"
                    >
                      또는 소셜 계정으로 간편하게 로그인하세요.
                    </p>
                    <button
                      type="button"
                      @click="signInWithGoogle"
                      class="btn-social-google"
                      style="
                        background-color: #db4437;
                        color: white;
                        border: none;
                        padding: 10px 15px;
                        border-radius: 4px;
                        cursor: pointer;
                        margin-right: 10px;
                        font-size: 0.9em;
                      "
                    >
                      <!-- 구글 로고 SVG 또는 이미지 추가 권장 -->
                      구글 로그인
                    </button>
                    <button
                      type="button"
                      @click="signInWithKakao"
                      class="btn-social-kakao"
                      style="
                        background-color: #fee500;
                        color: #3c1e1e;
                        border: none;
                        padding: 10px 15px;
                        border-radius: 4px;
                        cursor: pointer;
                        font-size: 0.9em;
                      "
                    >
                      <!-- 카카오 로고 SVG 또는 이미지 추가 권장 -->
                      카카오 로그인
                    </button>
                  </div>
                </template>
                <div v-if="loginType === 'user'" class="login-btn-box">
                  <router-link :to="`${USER_ROUTES.Join.Path}`"
                    >회원가입</router-link
                  >
                  <span
                    ><a href="#" @click.prevent="openForgotPasswordModal"
                      >비밀번호 찾기</a
                    ></span
                  >
                </div>
              </div>
            </div>
            <!-- 앱 로그인 -->

            <!-- //앱 로그인 -->
          </form>
        </div>
        <div v-else class="glores-B-login">
          <h3 class="glores-B-login-title"><span>로그인 정보</span></h3>
          <div
            class="glores-B-login-msg"
            style="padding: 20px; text-align: center; font-size: 1.1em"
          >
            <div>
              <strong>{{ loggedInUserId }}</strong
              >님으로 로그인 되어있습니다.
            </div>
          </div>
          <div
            class="glores-B-login-btns"
            style="text-align: center; padding-bottom: 20px"
          >
            <button
              @click="handleLogout"
              class="btn-logout"
              style="
                padding: 10px 20px;
                background-color: #555;
                color: white;
                border: none;
                border-radius: 4px;
                cursor: pointer;
              "
            >
              로그아웃
            </button>
          </div>
        </div>
      </div>
      <!-- 비밀번호 찾기 모달 -->
      <n-modal
        v-model:show="showForgotPasswordModal"
        preset="card"
        style="width: 500px"
        title="비밀번호 찾기/재설정"
        :mask-closable="false"
        :closable="true"
        @after-leave="forgotPasswordUid = ''"
      >
        <p style="margin-bottom: 15px">
          아이디를 입력해주세요. 가입 시 등록된 이메일 주소로 임시 비밀번호가
          전송됩니다. 로그인 후 반드시 비밀번호를 변경해주세요.
        </p>
        <n-form @submit.prevent="handleForgotPasswordRequest">
          <n-form-item label="아이디" path="forgotPasswordUid">
            <n-input
              v-model:value="forgotPasswordUid"
              placeholder="아이디 입력"
              @keydown.enter.prevent="handleForgotPasswordRequest"
            />
          </n-form-item>
          <n-space justify="end">
            <n-button
              @click="closeForgotPasswordModal"
              :disabled="forgotPasswordLoading"
              >취소</n-button
            >
            <n-button
              type="primary"
              attr-type="submit"
              :loading="forgotPasswordLoading"
            >
              임시 비밀번호 발송
            </n-button>
          </n-space>
        </n-form>
      </n-modal>
    </div>
  </div>
</template>

<script setup lang="ts">
import Banner from "@/components/Banner.vue";
import { USER_ROUTES } from "@/assets/route_constants.ts";
import { useAuth } from "@/composables/useAuth";

const {
  loginType,
  form,
  loading,
  isLoggedIn,
  loggedInUserId,
  signInWithGoogle,
  signInWithKakao,
  handleSubmit,
  handleLogout,
  showForgotPasswordModal,
  forgotPasswordUid,
  forgotPasswordLoading,
  openForgotPasswordModal,
  closeForgotPasswordModal,
  handleForgotPasswordRequest,
} = useAuth();
</script>
